import type { ITeacherModuleAttendanceRequest } from '@/entities/TeacherAttendance';

export const parseModuleAttendanceRouteParams = (
  intakeModuleId?: string,
  groupNumber?: string,
): { params: ITeacherModuleAttendanceRequest; skip: boolean } => {
  const intakeModuleIdNumber = intakeModuleId ? Number(intakeModuleId) : undefined;
  const groupNumberNum = groupNumber ? Number(groupNumber) : undefined;
  const skip =
    !intakeModuleIdNumber ||
    Number.isNaN(intakeModuleIdNumber) ||
    groupNumberNum === undefined ||
    Number.isNaN(groupNumberNum);

  return {
    params: {
      intakeModuleId: intakeModuleIdNumber ?? 0,
      groupNumber: groupNumberNum ?? 0,
    },
    skip,
  };
};
